import apiClient from './apiClient';

export const getArbitrageBets = (params = {}) => {
  return apiClient.get("/arbitrage-bet", {
    params: params,
  });
};

export const getArbitrageBetBookmakers = () => {
  return apiClient.get("/arbitrage-bet/bookmakers");
};